import { globalConstants } from "../../constants";

// Success action creator
export const success = (response, type, status) => {
  return {
    type: type + globalConstants.SUCCESS,
    data: response?.data || response,
  };
};

// Failure action creator
export const failure = (error, type, status) => {
  return {
    type: type + globalConstants.FAILIUR,
    data: error?.message || error,
  };
};

// Custom action creator
export const customAction = (payload, type, status) => {
  return {
    type,
    payload: {
      status,
      ...payload,
    },
  };
};
